import { Item } from 'components/CollabItem/Item'
import { observer } from 'mobx-react-lite'
import { Comment } from 'types'
import { NOOP } from 'utils'
import { ItemBody, ItemFooter, ItemHeader } from '../CommentV2/CommentItem/CommentItem'
import { MarkDecisionControl } from './MarkDecisionControl'
import { UnreadDot } from 'components/CollabItem/UnreadDot/UnreadDot'

interface Props {
  comment: Comment
}

const CommentItem = observer(({ comment }: Props) => {
  return (
    <Item.Root editing={false}>
      <UnreadDot isUnread={!comment.read_status} />
      <Item.ControlGroupBox>
        <MarkDecisionControl comment={comment} />
      </Item.ControlGroupBox>
      <ItemHeader comment={comment} />
      <ItemBody comment={comment} />
      <ItemFooter comment={comment} />
      <Item.Reactions isDisabled reactions={comment.reactions} onToggleReaction={NOOP} />
    </Item.Root>
  )
})

export { CommentItem }
